import { gql } from '@apollo/client';

import { ContactFragment } from 'src/graphql/actions/contact/contact.fragment';

export const DepositorPolicyFragment = gql`
  fragment DepositorPolicyFragment on DepositorPolicy {
    update
  }
`;

export const DepositorFields = gql`
  ${ContactFragment}
  ${DepositorPolicyFragment}
  fragment DepositorFields on Depositor {
    city
    companyName
    companyRegistrationNumber
    companyWebsite
    country
    id
    postalCode
    region
    street
    streetNumber
    contacts {
      ...ContactFragment
    }
    policy {
      ...DepositorPolicyFragment
    }
  }
`;
